module.exports = __webpack_public_path__ + "img/run-for-good.e8903f1f.png";